export type BudgetSpec = {
  budget_value: number;
  budget_value_type: "PERCENTAGE" | "DECIMAL";
  margin: number;
};

export type PolicyScope = {
  scope_type: string;
  scope_key: string;
};

export class Policy {
  id: number;
  concept: string;
  spec: BudgetSpec;
  name: string;
  priority: number;
  scopes: PolicyScope[];

  constructor(data?: Partial<Policy>) {
    this.id = -1;
    this.concept = data?.concept || "BUDGET";
    this.spec = data?.spec || {
      budget_value: 0,
      budget_value_type: "DECIMAL",
      margin: 0,
    };
    this.name = data?.name || "";
    this.priority = data?.priority || 0;
    this.scopes = data?.scopes || [];
  }
}
